"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'botTest.list.name': 'Test Name',
    'botTest.list.date': 'Test Date',
    'botTest.list.testersCount': 'Testers',
    'botTest.list.targetsCount': 'Targets',
};
